import { AuthResponseDto, LoginDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";
import { trackEvent } from "@/client/utils/analytics";

export const login = async (data: LoginDto) => {
  try {
    const response = await axios.post<AuthResponseDto, AxiosResponse<AuthResponseDto>, LoginDto>(
      "/auth/login",
      data,
    );
    trackEvent({
      userType: "youth",
      apiName: "login",
      userId: response.data.user?.id,
      success: true,
    });
    return response.data;
  } catch (error) {
    trackEvent({ userType: "youth", apiName: "login", success: false });
    throw error;
  }
};

export const useLogin = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: loginFn,
  } = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      if (data.status === "2fa_required") {
        return navigate("/auth/verify-otp");
      }

      setUser(data.user);
      queryClient.setQueryData(["user"], data.user);
    },
  });

  return { login: loginFn, loading, error };
};
